const FORM_NAME_CHECKPOINT_ADD = 'checkpoint-add';
const FORM_NAME_CHECKPOINT_EDIT = 'checkpoint-edit';
const FORM_NAME_CHECKPOINT_DELETE = 'checkpoint-delete';

export {
  FORM_NAME_CHECKPOINT_ADD,
  FORM_NAME_CHECKPOINT_EDIT,
  FORM_NAME_CHECKPOINT_DELETE,
};